export default __webpack_public_path__ + "static/media/gallery_09.093a4b0d.jpg";